import script from "./homeVue.vue?vue&type=script&setup=true&lang=js"
export * from "./homeVue.vue?vue&type=script&setup=true&lang=js"

import "./homeVue.vue?vue&type=style&index=0&id=796a16d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-796a16d2"]])

export default __exports__